


const fetchCall = async (type2, id, diaInicio, mesInicio, diaFinal, mesFinal,yearInicio, yearFinal, anexos, calldate) => {

  if (type2) {
    var hosting = "";
    if(window.location.hostname === "localhost" ){
      hosting = "https://beta.megacall.cl";
    }
    const url = `${hosting}/mimegacall/api/${type2}.php`
    let formData = new FormData();
    
    if (diaInicio) {
      formData.append("diaInicio", diaInicio);
    }
    if (mesInicio) {
      formData.append("mesInicio", mesInicio);
    }
    if (diaFinal) {
      formData.append("diaFinal", diaFinal);
    }
    if (mesFinal) {
      formData.append("mesFinal", mesFinal);
    }
    if (yearFinal) {
      formData.append("yearFinal", yearFinal);
    }
    if (yearInicio) {
      formData.append("yearInicio", yearInicio);
    }
    if (calldate) {
      formData.append("calldate", calldate);
    }
    if (JSON.stringify(anexos).length >2) {
      formData.append("anexos", JSON.stringify(anexos));
    }else{
      return "Debes seleccionar al menos 1 anexo";
    }

    //

    const resp = await fetch(`${url}`, {
      headers: {
        'Accept': 'application/json',
      },
      method: "POST",
      body: formData
    }).then(async (data) =>{
      let respCall =  await data.json();
      
      /* if(Object.entries(respCall).length === 0){ 
        respCall = JSON.parse("0")
      } */
      return respCall;

    }).catch((err) =>{
      return err;
    })
    
  return resp;


}


}

export default fetchCall;